import { Navigate, Route, Routes } from "react-router-dom";
import { observer } from "mobx-react-lite";

import authStore from "../../stores/AuthStore";
import { UserRoles } from "../../stores/AuthStore/types";
import configStore, { Flags } from "../../stores/ConfigStore";

import Login from "../Login";
import Home from "../Home";
import UserCases from "../UserCases";
import CaseDetails from "../CaseDetails";
import Premium from "../Premium";
import Offers from "../Offers";
import CaseSearch from "../CaseSearch";
import Profile from "../Profile";
import Delegation from "../Delegation";
import ForgotPassword from "../ForgotPassword";
import Notifications from "../Notifications";
import IncomingOffers from "../IncomingOffers";
import DictionaryManagement from "../Admin/DictionaryManagement";
import CategoriesManagement from "../Admin/CategoriesManagement";
import StaticContentManagement from "../Admin/StaticContentManagement";

const RootRouter = observer(() => {
  return (
    <Routes>
      <Route
        path={"/"}
        element={
          authStore.isAuthenticated ? <Home /> : <Navigate to={"/login"} />
        }
      />
      <Route
        path={"/home"}
        element={
          authStore.isAuthenticated ? <Home /> : <Navigate to={"/login"} />
        }
      />
      <Route
        path={"/profile"}
        element={
          authStore.isAuthenticated ? <Profile /> : <Navigate to={"/login"} />
        }
      />
      <Route
        path={"/notifications"}
        element={
          authStore.isAuthenticated ? (
            <Notifications />
          ) : (
            <Navigate to={"/login"} />
          )
        }
      />
      <Route
        path={"/cases"}
        element={
          authStore.isAuthenticated ? (
            <UserCases fetchCases={true} fetchOffers={true} />
          ) : (
            <Navigate to={"/login"} />
          )
        }
      />
      <Route
        path={"/case/:id"}
        element={
          authStore.isAuthenticated ? (
            <CaseDetails />
          ) : (
            <Navigate to={"/login"} />
          )
        }
      />
      <Route
        path={"/delegation/:id"}
        element={
          authStore.isAuthenticated &&
          authStore.userHasRole(UserRoles.LAWYER) ? (
            <Delegation />
          ) : (
            <Navigate to={"/login"} />
          )
        }
      />
      <Route
        path={"/search/:role"}
        element={
          authStore.isAuthenticated ? (
            <CaseSearch />
          ) : (
            <Navigate to={"/login"} />
          )
        }
      />
      <Route
        path={"/offers"}
        element={
          authStore.isAuthenticated ? <Offers /> : <Navigate to={"/login"} />
        }
      />
      <Route
        path={"/incoming-offers"}
        element={
          authStore.isAuthenticated ? (
            <IncomingOffers />
          ) : (
            <Navigate to={"/login"} />
          )
        }
      />
      <Route
        path={"/dictionary-management"}
        element={
          authStore.userHasRole(UserRoles.ADMIN) ? (
            <DictionaryManagement />
          ) : (
            <Navigate to={"/"} />
          )
        }
      />
      <Route
        path={"/categories-management"}
        element={
          authStore.userHasRole(UserRoles.ADMIN) ? (
            <CategoriesManagement />
          ) : (
            <Navigate to={"/"} />
          )
        }
      />
      <Route
        path={"/static-content-management/:key"}
        element={
          authStore.userHasRole(UserRoles.ADMIN) ? (
            <StaticContentManagement />
          ) : (
            <Navigate to={"/"} />
          )
        }
      />
      {configStore.getFlag(Flags.isPremiumEnabled) && (
        <Route
          path={"/premium"}
          element={
            authStore.isAuthenticated ? <Premium /> : <Navigate to={"/login"} />
          }
        />
      )}
      <Route path={"/login"} element={<Login />} />
      <Route path={"/forgotPassword"} element={<ForgotPassword />} />
    </Routes>
  );
});

export default RootRouter;
